import type { BasketContentViewModel } from 'autogen/swagger/all';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import SampleBasketEntrance from 'components/samples/components/entrance';
import Flex from 'components/Layout/components/Flex';

import UnclaimedGifts from './components/UnclaimedGifts';

export default function BasketGiftSelect({ model }: { model: BasketContentViewModel }) {
    const { unclaimedGifts, optedOutGifts, samples } = model.basket;
    const { hasUnclaimedSamples } = samples;
    const hasUnclaimedGifts = !!unclaimedGifts.length;
    const hasOptInGifts = !!optedOutGifts.length;

    const hasAvailableGifts = hasUnclaimedGifts || hasOptInGifts;

    if (!hasAvailableGifts && !hasUnclaimedSamples) return null;

    return (
        <>
            <Flex.Column gap={Spacing8}>
                {hasOptInGifts && <UnclaimedGifts model={optedOutGifts} OptInGift />}
                {hasUnclaimedGifts && <UnclaimedGifts model={unclaimedGifts} OptInGift={false} />}
                {hasUnclaimedSamples && <SampleBasketEntrance model={samples} />}
            </Flex.Column>
        </>
    );
}
